import { formatToCurrency } from "utils/currency";
import { FC } from "react";
import { cx } from "utils/classnames";

interface FeeDisplayProps {
  feeInCents: number;
  currency: string;
  className: string;
  label?: string;
  labelClassName?: string;
}

const FeeDisplay: FC<FeeDisplayProps> = ({
  feeInCents,
  currency,
  className,
  label,
  labelClassName
}) => {
  return (
    <p
      className={cx(
        className,
        feeInCents > 0
          ? "text-success-700"
          : feeInCents < 0
            ? "text-danger-600"
            : "text-content-400"
      )}
    >
      {label && <span className={labelClassName}>{label}: &nbsp;</span>}
      {feeInCents > 0 ? "+" : ""}
      {formatToCurrency({
        cents: feeInCents,
        currency
      })}
    </p>
  );
};

export default FeeDisplay;
